import styled from "styled-components";

export const StyledHeader = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 4rem;
  font-size: 2.8125rem;
  text-align: center;
  line-height: 4rem;
  color: ${({ theme }) => theme.header.fontColor};
  margin-top: 1rem;
  /* background-color: ${(props) => props.theme.header.backgroundColor}; */
  background: ${(props) => props.theme.header.background};
  /* box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); */
`;
